import { createFileRoute } from '@tanstack/react-router';
import { VersionPage } from '@/pages/version/VersionPage';

export const Route = createFileRoute('/version')({
  component: VersionPage
});
